import { useRef, useCallback } from "react";
import { selectThumbnails, useAppSelector } from "../../../store";
import { useMasonry } from "../../../hooks";
import { MediaPreview } from "../";
import { GalleryToolbar } from "./GalleryToolbar";
import "./MediaGallery.scss";

export const MediaGallery = () => {
  const thumbnails = useAppSelector(selectThumbnails);
  const masonryRef = useRef<HTMLDivElement>(null);

  const { positions, containerHeight, registerItemHeight } = useMasonry(
    masonryRef,
    thumbnails.length,
    { columnWidth: 150 }
  );

  const getItemStyle = useCallback((index: number): React.CSSProperties => {
    const pos = positions[index];
    if (!pos) return { opacity: 0 };
    return {
      position: "absolute",
      left: pos.x,
      top: pos.y,
      width: pos.width,
    };
  }, [positions]);

  return (
    <div className="media-gallery-section">
      <div 
        ref={masonryRef}
        className="media-gallery"
        style={{ height: containerHeight }}
      >
        {thumbnails.map((thumbnail, index) => (
          <MediaPreview 
            key={thumbnail.name}
            fileName={thumbnail.name}
            index={index}
            style={getItemStyle(index)}
            onHeightChange={registerItemHeight}
          />
        ))}
      </div>
      <GalleryToolbar />
      <span></span>
    </div>
  );
}